module.exports = __webpack_public_path__ + "img/no-saved-template.5d6abba5.svg";